<!-- <template>
  <el-cascader
    placeholder="层级"
    size="small"
    :options="options"
    :show-all-levels="false"
    :props="{ checkStrictly: true, lazy: true, lazyLoad: lazyLoad }"
    clearable
    v-bind="$attrs"
    v-on="$listeners"
    style="width: 100%"
  ></el-cascader>
</template>
<script>
export default {
  name: 'LevelSelect',
  data () {
    return {
      levels: []
    }
  },
  computed: {
    options () {
      return this.transformOptions(this.levels)
    }
  },
  methods: {
    transformOptions (list) {
      return list.map(ele => ({ value: ele.objectId, label: ele.name }))
    },
    async lazyLoad (node, resolve) {
      const res = await this.$tkParse.get('/classes/hierarchy', {
        params: {
          where: {
            parent: node.value
          }
        }
      })
      const datas = this.transformOptions(res.data.results)
      resolve(datas)
    }
  }
}
</script>
<style scoped>
.text-button {
  cursor: pointer;
  font-size: 14;
  color: #2fbf79;
}
.text-button-gray {
  color: #aaadb3;
}
</style> -->

<template>
   <a-select style="width: 100%" placeholder="层级" allowClear :filterOption="filterOption" v-bind="$attrs" v-on="$listeners">
      <a-select-option :value="item.tag" v-for="item in levels" :key="item.objectId" :optionFilterProp="item.name">
        {{ item.name }}
      </a-select-option>
    </a-select>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      levels: []
    }
  },
  computed: {
    ...mapGetters(['userLevelTag'])
  },
  created () {
    this.getAllUserLevels()
  },
  methods: {
    // 获取用户可编辑的所有的层级信息
    async getAllUserLevels () {
      const res = await this.$tkParse.get('/classes/hierarchy', {
        params: {
          where: {
            tag: {
              $regex: `^${this.userLevelTag}`
            }
          },
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      this.levels = res.data.results
    },
    filterOption (str, option) {
      return option.data.attrs.optionFilterProp.includes(str)
    }
  }
}
</script>

<style></style>
